export const TilesContainer: React.FC<{
	children: React.ReactNode;
}> = ({ children }) => {
	return <>{children}</>;
};
